import {
  Breadcrumb,
  Button,
  Card,
  Divider,
  Modal,
  Popover,
  Upload,
} from "antd";
import profileIcon from "../../../assests/images/profile_large.jpg";
import avatar1 from "../../../assests/icons/avatar1.png";
import avatar2 from "../../../assests/icons/avatar2.png";
import avatar3 from "../../../assests/icons/avatar3.png";
import avatar4 from "../../../assests/icons/avatar4.png";
import avatar5 from "../../../assests/icons/avatar5.png";
import avatar6 from "../../../assests/icons/avatar6.png";
import avatar7 from "../../../assests/icons/avatar7.png";
import avatar8 from "../../../assests/icons/avatar8.png";
import avatar9 from "../../../assests/icons/avatar9.png";
import { useState, useCallback, useEffect } from "react";
import { MdOutlineEdit } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router";
import SendMoneyService from "../../../services/send-money.service";
import { AiOutlineLeft } from "react-icons/ai";
import CommonOtp from "../../../components/otp";
import { useSelector } from "react-redux";
import { modeSelector } from "../../../store/selectors/app.selector";
import { amountFormat } from "../../../services/common.service";
import AccountCard from "../../../components/account-card";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import OTP from "../../../components/otp";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function InternationalPayeeDetails() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const location = useLocation();
  const [payeeDetails, setPayeeDetails] = useState({});
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [type, setType] = useState("VIEW");
  const [stage, setStage] = useState(1);
  const [payeeImage, setPayeeImage] = useState("");
  const mode = useSelector(modeSelector);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  useEffect(() => {
    if (location.state) {
      setType(location.state.type);
      setPayeeDetails(location.state);
      getPayeeImages(location.state);
    }
  }, []);

  const getPayeeImages = useCallback(
    async (payeeDetails) => {
      try {
        setPopoverVisible(false);
        const req = {
          mode: mode,
          accNo: [payeeDetails.beneAccNo],
        };
        setLoader(true);
        const response = await SendMoneyService.getPayeeImages(req);
        if (response.status === 200) {
          setLoader(false);
          setPayeeImage(response.data["data"]["imagesList"][0]?.imageData);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [payeeDetails]
  );

  const verifyDeletePayee = useCallback(async () => {
    try {
      setLoading(true);
      const response = await SendMoneyService.verifyDeletePayee({
        reqId: payeeDetails?.reqId,
        beneAccNo: payeeDetails?.beneAccNo,
        mode: mode,
        authType: "A",
        beneType: "INTERNATIONAL",
      });
      if (response.status === 200) {
        setLoading(false);
        setStage(2);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [payeeDetails]);

  const deletePayeeConfirm = useCallback(
    async (values) => {
      try {
        setLoader(true);
        const response = await SendMoneyService.deletePayeeConfirm({
          ...values,
          mode: mode,
          beneType: "INTERNATIONAL",
          authType: "A",
        });
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setDeleteVisible(true);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [payeeDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return (
          <OTP
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              deletePayeeConfirm({
                reqId: payeeDetails?.reqId,
                beneAccNo: payeeDetails?.beneAccNo,
                ...values,
                otp,
              })
            }
            handleResendOtp={() => verifyDeletePayee()}
            cancelTransaction={() => {
              setStage(1);
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row profile-details">
          <div align="center">
            {payeeImage !== null && payeeImage?.length > 0 ? (
              <img
                src={payeeImage}
                alt="Profile"
                height={120}
                width={120}
                style={{ backgroundColor: "#108ee9" }}
              />
            ) : (
              <img src={profileIcon} alt="Profile" height={120} />
            )}
          </div>
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}{" "}
              </label>
              <span>{payeeDetails?.beneName || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bene_nick_name", {
                  defaultValue: "Beneficiary Nick Name",
                })}
              </label>
              <span>{payeeDetails?.beneNickName || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span> {payeeDetails?.beneAccNo || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.mode_transfer", {
                  defaultValue: "Mode of Transfer",
                })}
              </label>
              <span>
                {payeeDetails?.modeOfTransfer === "ROUTE"
                  ? t("pages.Add_Bene.routing_number", {
                      defaultValue: "Routing Number",
                    })
                  : payeeDetails?.modeOfTransfer === "IFSC"
                  ? t("pages.Add_Bene.ifsc_code", {
                      defaultValue: "IFSC Code",
                    })
                  : t("pages.Add_Bene.swift_or_bic", {
                      defaultValue: "Swift / BIC Code",
                    })}
              </span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {payeeDetails?.modeOfTransfer === "ROUTE"
                  ? t("pages.Add_Bene.routing_number", {
                      defaultValue: "Routing Number",
                    })
                  : payeeDetails?.modeOfTransfer === "IFSC"
                  ? t("pages.Add_Bene.ifsc_code", {
                      defaultValue: "IFSC Code",
                    })
                  : t("pages.Add_Bene.swift_or_bic", {
                      defaultValue: "Swift / BIC Code",
                    })}
              </label>
              <span>{payeeDetails?.swiftCode}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bank_country", {
                  defaultValue: "Bank Country",
                })}
              </label>
              <span>{payeeDetails?.bankCountry || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.bank_name", {
                  defaultValue: "Bank Name",
                })}
              </label>
              <span>{payeeDetails?.bankName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bank_address", {
                  defaultValue: "Bank Address",
                })}
              </label>
              <span>{payeeDetails?.bankAddress || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.Add_Bene.bene_currency", {
                  defaultValue: "Beneficiary Currency",
                })}
              </label>
              <span>{payeeDetails?.beneCurrency || "-"}</span>
            </div>

            {/* <div className="confirm-label-wrapper">
              <label>Beneficiary Email</label>
              <span>{payeeDetails?.beneEmail || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>Beneficiary Mobile Number</label>
              <span>{payeeDetails?.beneMobileNo || "-"}</span>
            </div> */}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.transfer_limit.transfer_limit", {
                  defaultValue: "Transfer Limit",
                })}
              </label>
              <span>
                {amountFormat(
                  payeeDetails?.maxTransferLimit,
                  payeeDetails?.beneCurrency
                )}
              </span>
            </div>
          </div>
        </div>

        {type === "DELETE" && (
          <p style={{ marginTop: 30, fontSize: 15 }}>
            {t("pages.Add_Bene.delete_trans_txt", {
              defaultValue:
                "Note : If you proceed, any scheduled transfers to this beneficiary will also get deleted",
            })}
          </p>
        )}

        {type === "VIEW" && (
          <div className="mt-5 payee-details-btn-group" align="right">
            <Button
              className="secondary-btn mx-5"
              onClick={() =>
                navigate(
                  "/beneficiary-management/international-beneficiary-modify",
                  {
                    state: { ...payeeDetails, mode: "MODIFY" },
                  }
                )
              }
              size="large"
            >
              {t("pages.Add_Bene.modify_beneficiary", {
                defaultValue: "Modify Beneficiary",
              })}
            </Button>
            <Button onClick={() => setType("DELETE")} danger size="large">
              {t("pages.Add_Bene.delete_deneficiary", {
                defaultValue: "Delete Beneficiary",
              })}
            </Button>
          </div>
        )}

        {type === "DELETE" && (
          <div className="mt-5 payee-details-btn-group d-flex justify-content-end">
            <Button
              style={{ marginRight: 20 }}
              onClick={() =>
                type === location.state?.type
                  ? navigate("/send-money")
                  : setType("VIEW")
              }
              size="large"
              className="secondary-btn"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              type="primary"
              onClick={() => verifyDeletePayee()}
              // loading={loading}
              size="large"
              className="primary-btn mx-3"
            >
              {t("buttons.proceed_btn", {
                defaultValue: "Proceed",
              })}
            </Button>
          </div>
        )}
      </>
    );
  }
  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/transfer")}>
              {" "}
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => navigate("/send-money/manage-beneficiary")}
          >
            <span>
              {" "}
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.Add_Bene.international_beneficiary", {
                defaultValue: "International Beneficiary",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"   >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title=""
        open={deleteVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>
          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              type="primary"
              onClick={() => {
                setDeleteVisible(false);
                navigate("/send-money/manage-beneficiary");
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
